import React from "react";
import box from "../../../../assets/Icons/box.png";
import bundle from "../../../../assets/Icons/bundle.png";
import email from "../../../../assets/Icons/email.png";

const packageDetails = [
  {
    img: email,
    id: "A4_Envelope",
    name: "A4 Envelope",
    size: "12 × 9 × 1 in",
    accent: "#ea580c",
  },
  {
    img: bundle,
    id: "Small_Box",
    name: "Small Box",
    size: "18 × 15 × 13 in",
    accent: "#2563eb",
  },
  {
    img: box,
    id: "Moving_Box",
    name: "Moving Box",
    size: "30 × 18 × 18 in",
    accent: "#15803d",
  },
];

const BookingRemaining = ({ data }) => {
  const meta =
    packageDetails.find((item) => item.id === data?.boxName) || {
      img: box,
      name: data?.boxName?.replaceAll("_", " ") || "Box",
      size: "",
      accent: "#6D4C41",
    };

  const used = Number(data?.boxAssignCurrentMonth) || 0;
  const limit = Number(data?.limitCurrentMonth) || 0;
  const pct =
    limit > 0 ? Math.min(100, Math.round((used / limit) * 100)) : 0;

  return (
    <div className="relative overflow-hidden w-full rounded-2xl border border-[#e8ddd4] bg-white p-5 shadow-sm">
      <div
        className="absolute left-0 top-0 h-full w-1.5"
        style={{ backgroundColor: meta.accent }}
      />
      <div className="flex w-full justify-between items-start gap-4">
        <div className="min-w-0">
          <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-stone-500">
            {meta.name}
          </p>
          {meta.size ? (
            <p className="text-xs font-medium text-stone-500 mt-0.5">
              {meta.size}
            </p>
          ) : null}
          <p
            className="text-4xl font-black tabular-nums tracking-tight mt-2"
            style={{ color: meta.accent }}
          >
            {used}
          </p>
          <p className="text-xs text-stone-500 mt-1">Assigned this month</p>
        </div>
        <div
          className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl"
          style={{ backgroundColor: `${meta.accent}14` }}
        >
          <img className="w-7 h-7 object-contain" src={meta.img} alt="" />
        </div>
      </div>
      <div className="mt-5">
        <div className="mb-1.5 flex items-center justify-between text-[11px] font-semibold text-stone-500">
          <span>{pct}% of monthly limit</span>
          <span className="tabular-nums">
            {used}/{limit || "—"}
          </span>
        </div>
        <div className="h-2 w-full overflow-hidden rounded-full bg-stone-100">
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{ width: `${pct}%`, backgroundColor: meta.accent }}
          />
        </div>
      </div>
    </div>
  );
};

export default BookingRemaining;
